module.exports = __webpack_public_path__ + "img/logoGrandE.3e196d58.svg";